import { render, staticRenderFns } from "./SortNumber.vue?vue&type=template&id=1663f9d2"
import script from "./SortNumber.vue?vue&type=script&lang=js"
export * from "./SortNumber.vue?vue&type=script&lang=js"
import style0 from "./SortNumber.vue?vue&type=style&index=0&id=1663f9d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports